<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div [hidden]="!isLoading" class="text-xs-center">
  <i class="fas fa-cog fa-spin fa-3x"></i> <span>{{ message }}</span>
</div>
